export const BULK_OPERATIONS_SECTION_EVENT = 'canvas-agent:bulk-operations:section';
export const BULK_OPERATIONS_TASKS_SECTION_EVENT =
	'canvas-agent:bulk-operations:tasks-section';
export const BULK_OPERATIONS_FILTER_EVENT = 'canvas-agent:bulk-operations:filter';
export const BULK_OPERATIONS_CONFIG_AUDIT_SECTION_EVENT =
	'canvas-agent:bulk-operations:config-audit-section';
